import { Controller } from "@hotwired/stimulus"

// After the visit drawer saves, leave the frame and open the journal again.
export default class extends Controller {
  static values = { url: String }

  connect() {
    const url = this.urlValue
    if (!url) return
    if (window.Turbo) window.Turbo.visit(url)
    else window.location.assign(url)
  }
}
